import { TRevenueSpendHistory } from './type.TRevenueSpendHistory'
import { IAccount } from './interface.IAccount'
import { IRevenueAgency } from './interface.IRevenueAgency'
import { IRevenue } from './interface.IRevenue'
import { IOfferSpend } from './interface.IOfferSpend'

export type IRevenueSpend = {
	id: number
	accountId: number
	agencyId: number
	at: Date
	amount: number
	notes: string | null
	history: Array<TRevenueSpendHistory>
	createdAt: Date
	updatedAt: Date

	account?: IAccount
	agency?: IRevenueAgency
}

export type TRevenueSpendAgg = IRevenueSpend & {
	percent: number
}

export type TRevenueAgg = IRevenue & {
	accountId: number
	teamReport: string
	ktLogin: string
	at: Date
}

export type TOfferSpendAgg = Omit<IOfferSpend, 'history'> & {
	accountId: number
	teamReport: string
	ktLogin: string
	percent: number
}

export type TRevenueSpendByAccount = IAccount & {
	at: Date
	spendTotal: number | null
	accountFBTotal: number | null
	creoTotal: number | null
	installsTotal: number | null
	agencyPercentTotal: number | null
	slicesTotal: number | null
	spend: Array<TRevenueSpendAgg>
	profit: number | null
	roi: number | null
	revenueTotal: number | null
	revenue: Array<TRevenueAgg>
	revenueCpaTotal: number | null
	revenueCpa: Array<TRevenueAgg>
	revenueSpendTotal: number | null
	revenueSpend: Array<TRevenueAgg>
	offerSpendTotal: number | null
	offerSpend: Array<TOfferSpendAgg>
}

export const REVENUE_SPEND_TOTAL_KEYS = [
	'spendTotal',
	'accountFBTotal',
	'creoTotal',
	'installsTotal',
	'agencyPercentTotal',
	'slicesTotal',
	'profit',
	'roi',
	'revenueTotal',
	'revenueCpaTotal',
	'revenueSpendTotal',
	'offerSpendTotal'
] as const

export type TRevenueSpendTotalKeys = typeof REVENUE_SPEND_TOTAL_KEYS[number]

export type TRevenueSpendByAccountRevenueCpa = Pick<TRevenueSpendByAccount, 'revenueCpa'>
export type TRevenueSpendByAccountRevenueSpend = Pick<TRevenueSpendByAccount, 'revenueSpend'>
export type TRevenueSpendByAccountRevenue = Pick<TRevenueSpendByAccount, 'revenue'>
export type TRevenueSpendByAccountSpend = Pick<TRevenueSpendByAccount, 'spend'>
export type TRevenueSpendByAccountOfferSpend = Pick<TRevenueSpendByAccount, 'offerSpend'>

export type TRevenueSpendByTeam = {
	at: Date
	teamReport: string
	spendTotal: number | null
	accountFBTotal: number | null
	creoTotal: number | null
	installsTotal: number | null
	agencyPercentTotal: number | null
	slicesTotal: number | null
	spend: Array<TRevenueSpendAgg>
	profit: number | null
	roi: number | null
	revenueTotal: number | null
	revenue: Array<TRevenueAgg>
	revenueCpaTotal: number | null
	revenueCpa: Array<TRevenueAgg>
	revenueSpendTotal: number | null
	revenueSpend: Array<TRevenueAgg>
	offerSpendTotal: number | null
	offerSpend: Array<TOfferSpendAgg>
}

export type TRevenueSpendByTeamRevenueCpa = Pick<TRevenueSpendByTeam, 'revenueCpa'>
export type TRevenueSpendByTeamRevenueSpend = Pick<TRevenueSpendByTeam, 'revenueSpend'>
export type TRevenueSpendByTeamRevenue = Pick<TRevenueSpendByTeam, 'revenue'>
export type TRevenueSpendByTeamSpend = Pick<TRevenueSpendByTeam, 'spend'>
export type TRevenueSpendByTeamOfferSpend = Pick<TRevenueSpendByTeam, 'offerSpend'>